// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "form-HtGtx";
export { _1 as "__esModule", _2 as "form" }
export default { "__esModule": _1, "form": _2 }
